import $ from 'jquery'
import teacherDialog from '../../../views/jst/registration/teacherDialog.handlebars'
import deparam from 'compiled/util/deparam'
import I18n from 'i18nObj'

export default (signupDialog) ->

    signupDialog.afterRender = ->
      $org     = $('#teacher_organization_type')
      $title   = $('#teacher_school_position')
      optsHtml = $title.html()

      $title.prop('disabled', true)

      $org.on 'change', ->
        $title.html(optsHtml)
        switch $org.val()
          when 'Higher Ed', 'Higher Ed For-Profit'
            $title.prop('disabled', false)
            .find('.k-12, .corporate, .government').remove()
          when 'K12', 'K12 For-Profit'
            $title.prop('disabled', false)
            .find('.higher-ed, .corporate, .government').remove()
          when 'Corporate'
            $title.prop('disabled', false)
            .find('.k-12, .higher-ed, .government').remove()
          when 'Government'
            $title.prop('disabled', false)
            .find('.k-12, .higher-ed, .corporate').remove()
          else
            $title.prop('disabled', true)

    signupDialog.teardown = ->
      $('#teacher_organization_type').off('change')

    settings = ENV.ACCOUNT?.registration_settings
    if settings?.salesforce
      # template tracks some extra salesforce stuff
      signupDialog.templates.teacherDialog = teacherDialog

      params = deparam()
      settings.tracking_fields = [
        {name: "user[lead_source]", value: params.lead_source ? "Free_For_Teacher_Request"}
        {name: "user[lead_source_description]", value: params.lead_source_description ? I18n.strftime(new Date(), '%Y-%m-%d')}
      ]

    signupDialog
